export default __webpack_public_path__ + "static/media/ab-img.41f499bf.webp";